import React, { SVGProps } from 'react';

export const AngleLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    {...props}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M15 19.75a.744.744 0 0 1-.53-.22l-7-7a.75.75 0 0 1 0-1.061l7-7a.75.75 0 0 1 1.06 1.061L9.06 12l6.47 6.47a.75.75 0 0 1-.53 1.28Z"
    />
  </svg>
);
